module.exports = __webpack_public_path__ + "static/img/DVB2-DjkE-_08.82926df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DVB2-DjkE-_08.png
// module id = sn1O
// module chunks = 16